"use client";

import { useRouter } from "next/navigation";
import LoginForm from "@/auth/_components/login-form";
import { Trans } from "@lingui/macro";
import { useAlertStore } from "@/components/context/alert-store";
import AlertComponent from "@/components/core/alert";
import withNoAuth from "@/utils/withNoAuth";
import Advantages from "@/auth/_components/advantages";
import Logo from "@/components/core/logo-offerz";

const Login = () => {
  const { message, setMessage } = useAlertStore();
  const router = useRouter();

  const handleRegisterClick = (type: "private" | "business") => {
    router.push(`/register?tab=${type}`);
  };

  return (
    <main className="md:px-5 md:py-[100px]">
      <div className="container relative rounded-[25px] bg-white px-5 pb-[100px] pt-[15px] md:mx-auto md:px-[35px] md:pt-[35px]">
        {message && <AlertComponent message={message} setMessage={setMessage} isMain={false} />}
        <Logo />
        <div className="container mx-auto">
          <div className="mt-[62px] flex flex-col md:flex-row md:px-2.5 lg:px-[65px]">
            <section className="w-full md:border-r md:border-[#e0e0e0] md:pr-[65px] lg:pr-[96px]">
              <p className="mb-[15px] text-[22px] font-extrabold tracking-[-0.3px] md:mb-[10px] md:text-[30px] md:tracking-[-0.6px]">
                <Trans>Sign in</Trans>
              </p>
              <p className="mb-[40px] md:mb-[50px]">
                <Trans>Sign in with your Offerz account.</Trans>
              </p>

              <LoginForm />
            </section>

            <section className="w-full pt-[60px] md:pl-[65px] md:pt-0 lg:pl-[96px]">
              <p className="mb-[15px] text-[22px] font-extrabold tracking-[-0.3px] md:mb-[10px] md:text-[30px] md:tracking-[-0.6px]">
                <Trans>Register</Trans>
              </p>
              <p className="mb-6">
                <Trans>
                  Create an Offerz customer account and benefit from the following advantages:
                </Trans>
              </p>

              <Advantages />

              <div className="flex flex-col gap-5 pt-7">
                <button
                  data-testid="register-private-btn"
                  onClick={() => handleRegisterClick("private")}
                  className="w-full rounded-md border border-primary bg-white px-4 py-2 text-primary transition hover:bg-gray-50"
                >
                  <Trans>Register as a private customer</Trans>
                </button>
                <button
                  data-testid="register-business-btn"
                  onClick={() => handleRegisterClick("business")}
                  className="w-full rounded-md border border-primary bg-white px-4 py-2 text-primary transition hover:bg-gray-50"
                >
                  <Trans>Register as a business customer</Trans>
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </main>
  );
};

export default withNoAuth(Login);
